import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "asyncComponents" */'../../../../asyncComponents').then(module => module.ActionsDropdownContent),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered"
  }),
  ErrorComponent: ({
    error
  }) => {
    Raven.captureException(error);
    console.error(error);
    return null;
  }
});